/* import __COLOCATED_TEMPLATE__ from './page.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { Card, CardStatus } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
import { getBusinessName, getCardholder, getCvc, getExpirationDateString, getFullPan } from '@banking/ui/utils/card/card';
import { inject as service } from '@ember/service';
import { getImageUriFromCardCustomization } from '@banking/ui/utils/card/image-bytes-utils';
import { isCardActivatable, isCardExpired, isInactiveReplacementCard } from '@banking/ui/utils/card-settings-utils';
const getCardPreviewFromCard = (card, cardCustomization) => {
  return {
    businessName: getBusinessName(card),
    cardholder: getCardholder(card),
    customizationImageDataURL: getImageUriFromCardCustomization(cardCustomization),
    cvc: getCvc(card),
    expirationDate: getExpirationDateString(card),
    fullPan: getFullPan(card)
  };
};
const EMPTY_CARD = {
  businessName: '',
  cardholder: '',
  customizationImageDataURL: '',
  cvc: '',
  expirationDate: '',
  fullPan: ''
};
let Index = (_class = class Index extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "features", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "userInfo", _descriptor3, this);
    _defineProperty(this, "CardStatus", CardStatus);
    // TODO(cvu): support different card brands once it's available in Card model
    _initializerDefineProperty(this, "cardIdentifierText", _descriptor4, this);
  }
  get cardPreview() {
    if (this.args.card && this.args.cardCustomization) {
      return {
        ...getCardPreviewFromCard(this.args.card, this.args.cardCustomization),
        showCardDetails: this.args.showCardDetails,
        isDigitalCard: this.args.card.cardType === Card.CardType.CARD_TYPE_DIGITAL
      };
    }
    return EMPTY_CARD;
  }
  get title() {
    const card = this.args.card;
    const cardholder = getCardholder(this.args.card);
    if (isInactiveReplacementCard(card)) {
      return this.intl.t('banking.checking.cardSettings.page.title.replacement');
    } else if (cardholder.length > 0) {
      return this.intl.t('banking.checking.cardSettings.page.title.cardholderName', {
        cardholder: getCardholder(card)
      });
    } else {
      return '';
    }
  }
  get activateCardButtonText() {
    return isInactiveReplacementCard(this.args.card) ? this.intl.t('banking.checking.cardSettings.page.status.activatable.button.activate.replacement') : this.intl.t('banking.checking.cardSettings.page.status.activatable.button.activate.default');
  }
  get showGetPhysicalCardButton() {
    return this.features.isEnabled('banking/decouple-checking-and-card') && this.args.card.cardType === Card.CardType.CARD_TYPE_DIGITAL && this.args.card.isEligibleForPhysicalCardPair && this.args.card.status !== CardStatus.CARD_STATUS_TERMINATED;
  }
  get showActivateCardButton() {
    return isCardActivatable(this.args.card) && !isCardExpired(this.args.card);
  }
  get isUsSeller() {
    return this.userInfo.countryCode === 'US';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "cardIdentifierText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return `Mastercard ${this.args.card.lastFour}`;
  }
}), _class);
export { Index as default };